// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps, IStoryMetaRequest } from "../../../constants";

const actionGetStoryMeta = (
  payload: IStoryMetaRequest,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryMetaForScreen,
  payload: { data:payload  },
  callback,
});


export {
  actionGetStoryMeta
};